import { render, staticRenderFns } from "./ErrorNotification.vue?vue&type=template&id=e3f360b2&scoped=true&"
import script from "./ErrorNotification.vue?vue&type=script&lang=js&"
export * from "./ErrorNotification.vue?vue&type=script&lang=js&"
import style0 from "./ErrorNotification.vue?vue&type=style&index=0&id=e3f360b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f360b2",
  null
  
)

export default component.exports